import { action, observable } from 'mobx';

class NestedPageStore {
  @observable isCreate = false;
  @observable isOpen?: boolean = true;

  constructor(open?: boolean) {
    this.isOpen = open;
  }
}

export default NestedPageStore;
